import React from "react";
import { Box, Text } from "rebass";

interface IProps {
  listName: string;
}

export const EmptyList: React.FC<IProps> = ({ listName }) => (
  <Box mx="75px" my="16px">
    <Text as="p" textAlign="center">
      No Files found.
    </Text>

    <Text as="p" textAlign="center">
      There are not any Files in <b>{listName}</b>.
    </Text>

    <Text as="p" textAlign="center">
      Please add file to listen.
    </Text>
  </Box>
);
